<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
    <p *ngFor="let paragraph of data.content">{{ paragraph }}</p>
</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Close</button>
</div>